<template>
    <div class="form-grid" style="max-width: 480px; margin: auto;">
            <div class="form-group col col-16" style="display: flex; justify-content: center;">
                <div class="cont-radios">
                  <div>
                    <input type="radio" id="yes" :value="1" v-model="filters.trade_in" />
                    <label for="yes">Si</label>
                  </div>
                  <div>
                    <input type="radio" id="no" :value="0" v-model="filters.trade_in" />
                    <label for="no">No</label>
                  </div>
                </div>
            </div>
                <div class="form-group col col-16" v-if="isTradeInTrue">
                    <small class="tx-lightgrey-1" style="font-size: calc(0.2vw + 0.60rem)">
                        Los campos marcados con <strong class="tx-black">*</strong> son requeridos
                    </small>
                </div>
                <div class="form-group col col-sm-8" v-if="isTradeInTrue">
                    <label class="form-label tx-gray-ad" for="brands_select">
                    Marca*
                    </label>
                    <ValidationProvider name="marca" rules="required" v-slot="{ errors }">
                    <v-select @click.native="loadBrands()"
                                v-model="filters.trade_in_used_car_info.brand"
                                :reduce="brands => brands"
                                :options="getBrands()"
                                placeholder="Seleccionar"
                                label="name"
                                class="form-input"
                                name="brands"
                                :clearable=false
                                id="brands_select"
                                @input="loadModels()"
                                style="min-width:200px;">
                    <span slot="no-options">
                        {{
                            brandsLoads && getBrands().length == 0
                                ? "Sin resultados"
                                : "Cargando..."
                        }}
                    </span>
                    </v-select>
                    <span class="tx-red-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group col col-sm-8" v-if="isTradeInTrue">
                    <label class="form-label tx-gray-ad" for="models_select">
                    Modelo*
                    </label>
                    <ValidationProvider name="modelo" rules="required" v-slot="{ errors }">
                    <v-select
                            v-model="filters.trade_in_used_car_info.model"
                            :reduce="models => models"
                            :options="getModels()"
                            placeholder="Seleccionar"
                            label="name"
                            class="form-input"
                            name="models"
                            :clearable=false
                            id="models_select"
                            style="min-width:200px;">
                    <span slot="no-options">{{
                            modelsLoads && getBrands().length == 0
                                ? "Sin resultados"
                                : "Seleccione una marca para continuar..."
                        }}</span>
                </v-select>
            <span class="tx-red-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group col col-sm-8" v-if="isTradeInTrue">
                    <label class="form-label tx-gray-ad" for="year_select">
                    Año*
                    </label>
                    <ValidationProvider name="año" rules="required" v-slot="{ errors }">

                    <v-select
                            v-model="filters.trade_in_used_car_info.year"
                            :reduce="years => years.value"
                            :options="getYears()"
                            placeholder="Seleccionar"
                            label="name"
                            class="form-input"
                            :clearable=false
                            name="year" id="year-select"
                            style="min-width:200px;">
                    </v-select>
                    <span class="tx-red-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group col col-sm-8" v-if="isTradeInTrue">
                    <label class="form-label tx-gray-ad" for="color_select">
                        Color*
                    </label>
                    <ValidationProvider name="color" rules="required" v-slot="{ errors }">
                    <v-select
                            v-model="filters.trade_in_used_car_info.color_id"
                            :reduce="colorsCarUsed => colorsCarUsed.value"
                            :options="getColors()"
                            @click.native="loadColors()"
                            placeholder="Seleccionar"
                            label="name"
                            class="form-input"
                            :clearable=false
                            name="color" 
                            id="color-select"
                            style="min-width:200px;">
                    <span slot="no-options">{{
                                colorsLoads && getColors().length == 0
                                    ? "Sin resultados"
                                    : "Seleccione un color para continuar..."
                            }}</span>
                    </v-select>
                    <span class="tx-red-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group col col-sm-8" v-if="isTradeInTrue">
                    <label class="form-label tx-gray-ad" for="kilometraje_select">
                    Kilometraje*
                    </label>
                    <ValidationProvider name="kilometraje" rules="required" v-slot="{ errors }">
                        <input
                            v-model="filters.trade_in_used_car_info.kilometers"
                            class="form-input"
                            :class="{'is-invalid': errors[0]}"
                            type="number"
                            placeholder="Kilometraje"
                            style="min-width:200px;"
                            />
                    <span class="tx-red-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group col col-sm-8" v-if="isTradeInTrue">
                    <label class="form-label tx-gray-ad" for="">
                    Número de dueños*
                    </label>
                    <ValidationProvider name="numero de dueños" rules="required|max_value:100" v-slot="{ errors }">
                        <input
                            v-model="filters.trade_in_used_car_info.owners"
                            class="form-input"
                            :class="{'is-invalid': errors[0]}"
                            type="numero_de_dueños"
                            placeholder="Número de dueños"
                            style="min-width:200px;"
                            id="numero_de_dueños"
                            />
                    <span class="tx-red-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
    </div>
    </template>

    <script>
    import {
      mapState
    } from "vuex";
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate";
    import es from 'vee-validate/dist/locale/es.json';

    import * as rules from "vee-validate/dist/rules";

    Object.keys(rules).forEach(rule => {
        extend(rule, rules[rule]);
    });
    Vue.component("v-select", vSelect);
    localize('es', es);
    const DEFAULT_YES = 1;

    export default {
        components:{
            ValidationObserver,
            ValidationProvider
        },
      props: {
        filters: {
          type: Object,
          required: true
        }
      },
      data() {
        return {
          brandsLoads: false,
          modelsLoads: false,
          colorsLoads: false
        }
      },
      computed: {
        isTradeInTrue() {
            return (this.filters.trade_in === DEFAULT_YES) ? true : false;
        }
      },
      watch: {
        filters: {
          handler(newVal) {
            this.$emit("filters", newVal);
          },
          deep: true
        },
        data: {
          handler(value) {
            if (value) {
              this.filters = value;
            }
          },
          deep: true
        }
      },
      methods: {
        loadBrands() {
            this.models = [];
            this.filters.models = []
            this.$store.dispatch("intelimotor/getBrands");
        },
        loadModels () {
          this.years = []
          this.filters.years = []
          this.$store.dispatch('intelimotor/getModels', this.filters.trade_in_used_car_info.brand.value)
        },
        loadColors() {
            this.colorsCarUsed = []
            this.$store.dispatch("intelimotor/getColors")
        },
        getBrands() {
          return _.map(this.$store.state.intelimotor.brands, function (item, key) {
            return {
              name: item.name,
              value: item.id
            };
          });
        },
        getModels() {
          return _.map(this.$store.state.intelimotor.models, function (item, key) {
            return {
              name: item.name,
              value: item.id
            };
          });
        },
        getYears() {
            let yearsObject = []
            let currentYear = new Date().getFullYear()
            for (let index = 0; index <= 7; index++) {
                    yearsObject.push({
                    name: currentYear - index,
                    value: currentYear - index
                })

            }
            return yearsObject;
        },
        getColors() {
            return _.map(this.$store.state.intelimotor.colors, function (item, key) {
            return {
              name: item.name,
              value: item.id
            };
          });
        }
      }
    }
    </script>


<style lang="css">
    input[type='radio'] {
        accent-color: black;
    }
    .cont-radios{
      width: 181px;
      display: flex;
      justify-content: space-evenly;
    }
</style>
